import React from "react"
import {
    Routes,
    Route,
    Navigate,
} from "react-router-dom"
import { PrivateRoute } from "./PrivateRoute"
import { publicRoutes, privateRoutes } from "./routes"
import { useAuth } from "hooks/useAuth"

// Public
import { ForgotPasswordPage, ActivateAccountPage, SigninPage } from "features/auth"
import { ErrorPage, ContactPage } from "features/misc"
import NotFound from "router/NotFound"
import NotAuthorized from "router/NotAuthorized"

// Private
import { SearchBikePage, BikePage, BikeUpdatedPage } from "features/bike"
import { TeamPage } from "features/Team"
import { HistoryPage } from "features/history"
import { PartnerInfo, SearchUserPage, PartnerCollection, PartnerCollectionFolders, PartnerPage, TeamPartner } from "features/Partner"
import { BikeCollectionImport } from "features/BikeCollectionImport"

export const Router = () => {
    const { entity } = useAuth()
    const entityRole = entity?.entity_data?.entity_permission?.role
    return (
        <Routes>
            {/* Public */}
            <Route path={publicRoutes.login.path} element={<SigninPage />} />
            <Route path={publicRoutes.lostPassword.path} element={<ForgotPasswordPage />} />
            <Route path={publicRoutes.activateAccount.path} search={publicRoutes.activateAccount.search} element={<ActivateAccountPage />} />
            <Route path="/" element={<Navigate to={publicRoutes.login.path} replace={true} />} />

            <Route path={publicRoutes.notFound.path} element={<NotFound />} />

            {/* Public - Bicycode */}
            {/* <Route path={publicRoutes.signup.path} element={<CreateAccount} /> */}

            {/* Protected - Global */}
			<Route element={<PrivateRoute />}>
                <Route
                    path={privateRoutes.home.path}
                    element={
                        entityRole === "MANAGEENTITIES" ? <PartnerCollection /> : <SearchBikePage />
                    }
                    roles={privateRoutes.bike.roles}
                />
                <Route path={privateRoutes.error.path} element={<ErrorPage />} />
                <Route path={privateRoutes.notAuthorized.path} element={<NotAuthorized />} />

                {/* Protected - Bike */}
                <Route
                    path={privateRoutes.bike.path}
                    element={<BikePage />}
                    roles={privateRoutes.bike.roles}
                />
                <Route
                    path={privateRoutes.searchBike.path}
                    element={<SearchBikePage />}
                    roles={privateRoutes.searchBike.roles}
                />
                <Route
                    path={privateRoutes.updatedBike.path}
                    element={<BikeUpdatedPage />}
                    roles={privateRoutes.updatedBike.roles}
                />

                {/* Protected - Partner / Shop */}
                <Route
                    path={privateRoutes.bikeCollectionImport.path}
                    element={<BikeCollectionImport />}
                    roles={privateRoutes.bikeCollectionImport.roles}
                />
                <Route
                    path={privateRoutes.team.path}
                    element={<TeamPage />}
                    roles={privateRoutes.team.roles}
                />
                <Route
                    path={privateRoutes.shop.path}
                    element={<PartnerInfo />}
                    roles={privateRoutes.shop.roles}
                />

                {/* Protected - History */}
                <Route
                    path={privateRoutes.history.path}
                    element={<HistoryPage />}
                    roles={privateRoutes.history.roles}
                />

                {/* Protected - Admin - partner enrolment */}
                <Route
                    path={privateRoutes.addPartner.path}
                    element={<PartnerPage />}
                    roles={privateRoutes.addPartner.roles}
                />
                <Route
                    path={privateRoutes.partner.path}
                    element={<PartnerPage />}
                    roles={privateRoutes.partner.roles}
                />
                <Route
                    path={privateRoutes.teamPartner.path}
                    element={<TeamPartner />}
                    roles={privateRoutes.teamPartner.roles}
                />
                <Route
                    path={privateRoutes.validatedPartner.path}
                    element={<PartnerCollection />}
                    roles={privateRoutes.validatedPartner.roles}
                />
                <Route
                    path={privateRoutes.validatePartner.path}
                    element={<PartnerCollectionFolders />}
                    roles={privateRoutes.validatePartner.roles}
                />

                <Route
                    path={privateRoutes.searchUser.path}
                    element={<SearchUserPage />}
                    roles={privateRoutes.searchUser.roles}
                />

                <Route
                    path={privateRoutes.contact.path}
                    element={<ContactPage />}
                    roles={privateRoutes.contact.roles}
                />              

                {/* Protected - Admin - Bicycode */}
                <Route
                    path={privateRoutes.bicycodeAdmin.path}
                    element={<TeamPage />}
                    roles={privateRoutes.bicycodeAdmin.roles}
                />
			</Route>

            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}